import {
  getProspects,
  getProspectTemplete,
  prospectCancel,
  putProspectTemplete,
  putProspectCancel,
  getProspectsTemplate,
  getAddressTemplate,
  getcCientsSearching,
  createProspects,
  getViewprospects,
  getViewprospectshistory,
  getQuotesViewQuotes,
  editProspects,
  getAddress,
  getChargeCode,
  getClientServiceTemplate,
  getQuotesPlans,
  createQuote,
  getPlanPricing,
  getClientService,
  getQuotes,
  elevatePropspect,
  getsStatus,
  convertToClient,
  editQuote,
  acceptQuoteStatus,
  cancelPropspect,
  deleteProspect,
  getFollowUp,
  createFollowUp,
  getCustomerId,
  sendQuoteMail,
  getCustomerview,
  getPlanPricingInfo,
  assignTo,
} from "@/http/leads";
export default {
  namespaced: true,
  state: {
    goodReceipt: {
      list: [],
      isLoading: false,
    },
    leadsHistory: [],
    cancelRemark: [],
    cancelPutRemark: [],
    prospectsTemplate: [],
    addressTemplate: {},
    ProspectsAction: null,
    leadInfo: {},
    prospectHistory: {},
    quoteList: {},
    clientSearch: {},
    getAddressSearch: {},
    allChargeTypes: [],
    clientServices: {},
    quotePlanList: [],
    CreateQuotes: null,
    planPriceData: [],
    clientService: [],
    quoteDetails: [],
    elavatedProspect: [],
    status: [],
    convertedClient: [],
    cancelledProspect: [],
    CustomerList: {},
    locationList: [],
    followUpOptions: [],
    customerId: {},
    planPricingInfo: {},
  },
  actions: {
    async leadsAction({ commit }) {
      try {
        const goodReceiptDetails = await getProspects();
        commit("GET_LEADS_HISTORY", goodReceiptDetails.data.pageItems);
        return goodReceiptDetails;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async leadsTemplete({ commit }, id) {
      try {
        const goodReceiptDetails = await getProspectTemplete(id);
        commit("GET_LEADS_TEMPLETE", goodReceiptDetails.data.statusRemarkData);
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async cancelProspect({ commit }, data) {
      try {
        return await prospectCancel(data.id, data.remark);
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async leadsPutTemplete({ commit }, id) {
      try {
        const goodReceiptDetails = await putProspectTemplete(id);
        commit("PUT_LEADS_TEMPLETE", goodReceiptDetails.data);
        return goodReceiptDetails;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async cancelPutProspect({ commit }, data) {
      try {
        return await putProspectCancel(data.id, data.data);
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async setProspectsTemplate({ commit }) {
      try {
        const resp = await getProspectsTemplate();
        commit("SET_PROSPECTS_TEMPLATE", resp.data);
        return resp;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async setAddressTemplate({ commit }) {
      try {
        const resp = await getAddressTemplate();
        commit("SET_ADDRESS_TEMPLATE", resp.data);
        return resp;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async setclientssearching({ commit }) {
      try {
        const resp = await getcCientsSearching();
        commit("SET_CLIENTS_SEARCHING", resp.data);
        return resp;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async createProspectsAction({ commit }, data) {
      try {
        const resp = await createProspects(data);
        commit("CREATE_PROSPECTS_ACTION", resp.data.resourceId);
        return resp;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async fetchLeadInfo({ commit }, id) {
      try {
        const resp = await getViewprospects(id);
        commit("SET_VIEW_PROSPECTS", resp.data);
        return resp;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async sendQuoteCreationMail(_, payload) {
      try {
        return await sendQuoteMail(payload);
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async fetchProospectHistory({ commit }, id) {
      try {
        const resp = await getViewprospectshistory(id);
        commit("SET_VIEW_PROSPECTS_HISTORY", resp.data);
        return resp;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async fetchAllQuotesInfo({ commit }, id) {
      try {
        const resp = await getQuotesViewQuotes(id);
        commit("SET_QUOTES_VIEW_QUOTES", resp.data);
        return resp;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async editProspectsAction({ commit }, data) {
      try {
        return await editProspects(data.id, data.data);
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async setAddress({ commit }, city) {
      try {
        const resp = await getAddress(city);
        commit("SET_ADDRESS", resp.data);
        return resp;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async fetchChargeCode({ commit }) {
      try {
        const resp = await getChargeCode();
        commit("SET_CHARGE_CODE", resp.data);
        return resp;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async fetchPlanPricingDetail({ commit }, payload) {
      try {
        const res = await getPlanPricingInfo(payload);
        commit("SET_PLAN_PRICING_INFO", {
          data: res.data.ratesDto,
          id: payload.productId,
        });
        return res;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async fetchClientServiceTemplate({ commit }) {
      try {
        const resp = await getClientServiceTemplate();
        commit("SET_CLIENT_SERVICE_TEMPLATE", resp.data);
        return resp;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async fetchQuotePlans({ commit }) {
      try {
        const resp = await getQuotesPlans();
        commit("SET_QUOTES_PLANS", resp.data);
        return resp;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async createQuoteAction({ commit }, data) {
      try {
        const resp = await createQuote(data.id, data.data);
        commit("CREATE_QUOTE_ACTION", resp.data.resourceId);
        return resp;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async fetchPlanPricing({ commit }, data) {
      try {
        const resp = await getPlanPricing(data.chargeCode, data.id);
        commit("SET_PLAN_PRICING", resp.data);
        return resp;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async fetchClientService({ commit }) {
      try {
        const resp = await getClientService();
        commit("SET_CLIENT_SERVICE", resp.data);
        return resp;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async fetchQuoteDetails({ commit }, data) {
      try {
        const resp = await getQuotes(data.id, data.QuoteId);
        commit("SET_VIEW_QUOTES", resp.data);
        return resp;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async elevateProspectAction({ commit }, data) {
      try {
        const resp = await elevatePropspect(data.id, data.data);
        commit("PROSPECTS_ELEVATE_ACTION", resp.data.resourceId);
        return resp;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async fetchStatus({ commit }, data) {
      try {
        const resp = await getsStatus(data);
        commit("SET_STATUS", resp.data);
        return resp;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async handleConvertToClient({ commit }, data) {
      try {
        const resp = await convertToClient(data.id, data.data);
        commit("CONVERT_TO_CLIENT_ACTION", resp.data.resourceId);
        return resp;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async editQuoteAction({ commit }, data) {
      try {
        return await editQuote(data.id, data.data);
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async acceptQuoteStatusAction({ commit }, data) {
      try {
        return await acceptQuoteStatus(data.id, data.data);
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async setProspectsCancel({ commit }, id) {
      try {
        const resp = await cancelPropspect(id);
        commit("SET_PROSPECTS_CANCEL", resp.data);
        return resp;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async deleteProspectsAction({ commit }, data) {
      try {
        const resp = await deleteProspect(data.id, data.statusRemark);
        commit("DELETE_PROSPECTS_ACTIONS", resp.data.resourceId);
        return resp;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async fetchFollowUpOptions({ commit }, id) {
      try {
        const resp = await getFollowUp(id);
        commit("SET_FOLLOW_UP", resp.data);
        return resp;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async createFollowUpAction({ commit }, data) {
      try {
        return await createFollowUp(data.id, data.data);
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async assignToAction({ commit }, data) {
      try {
        return await assignTo(data.id, data.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setCustomerId({ commit }, id) {
      try {
        const resp = await getCustomerId(id);
        commit("SET_CUSTOMER_ID", resp.data);
        return resp;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
  },
  mutations: {
    LOADING_GOOD_RECEIPT_DETAILS(state, payload) {
      state.goodReceipt.isLoading = payload;
    },
    GET_LEADS_HISTORY(state, payload) {
      state.leadsHistory = payload;
    },
    GET_LEADS_TEMPLETE(state, payload) {
      state.cancelRemark = payload;
    },
    PUT_LEADS_TEMPLETE(state, payload) {
      state.cancelPutRemark = payload;
    },
    SET_PROSPECTS_TEMPLATE(state, payload) {
      state.prospectsTemplate = payload;
    },
    SET_ADDRESS_TEMPLATE(state, payload) {
      state.addressTemplate = payload;
    },
    CREATE_PROSPECTS_ACTION(state, payload) {
      state.ProspectsAction = payload;
    },
    SET_VIEW_PROSPECTS(state, payload) {
      state.leadInfo = payload;
    },
    SET_VIEW_PROSPECTS_HISTORY(state, payload) {
      state.prospectHistory = payload;
    },
    SET_QUOTES_VIEW_QUOTES(state, payload) {
      state.quoteList = payload;
    },
    SET_CLIENTS_SEARCHING(state, payload) {
      state.clientSearch = payload;
    },
    SET_ADDRESS(state, payload) {
      state.getAddressSearch = payload;
    },
    SET_CHARGE_CODE(state, payload) {
      state.allChargeTypes = payload;
    },
    SET_CLIENT_SERVICE_TEMPLATE(state, payload) {
      state.clientServices = payload;
    },
    SET_QUOTES_PLANS(state, payload) {
      state.quotePlanList = payload;
    },
    CREATE_QUOTE_ACTION(state, payload) {
      state.CreateQuotes = payload;
    },
    SET_PLAN_PRICING(state, payload) {
      state.planPriceData = payload;
    },
    SET_CLIENT_SERVICE(state, payload) {
      state.clientService = payload;
    },
    SET_VIEW_QUOTES(state, payload) {
      state.quoteDetails = payload;
    },
    PROSPECTS_ELEVATE_ACTION(state, payload) {
      state.elavatedProspect = payload;
    },
    SET_STATUS(state, payload) {
      state.status = payload;
    },
    CONVERT_TO_CLIENT_ACTION(state, payload) {
      state.convertedClient = payload;
    },
    SET_PROSPECTS_CANCEL(state, payload) {
      state.cancelledProspect = payload;
    },
    DELETE_PROSPECTS_ACTIONS(state, payload) {
      state.DeleteProspect = payload;
    },
    SET_TICKET_CUSTOMER(state, payload) {
      state.CustomerList = payload;
    },
    ENTITY_LOC_ACTION(state, payload) {
      state.locationList = payload;
    },
    SET_FOLLOW_UP(state, payload) {
      state.followUpOptions = payload;
    },
    SET_CUSTOMER_ID(state, payload) {
      state.customerId = payload;
    },
    SET_PLAN_PRICING_INFO(state, payload) {
      state.planPricingInfo = {
        ...state.planPricingInfo,
        [payload.id]: payload.data,
      };
    },
  },
  getters: {
    getGoodReceiptList(state) {
      return state.goodReceipt.list;
    },
    goodReceiptIsLoading(state) {
      return state.goodReceipt.isLoading;
    },
  },
};
